
class CnCardSubCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <>
      {this.props.children}
    </>
  }
}
CnCardSubCard.displayName = 'CnCardSubCard'
export default CnCardSubCard;
